import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetDocumentQueueGroupsRequestType,
  GetDocumentQueueGroupsResponseType,
} from '../types';

export const getDocumentsQueueGroups = async (
  params: GetDocumentQueueGroupsRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue/groups`;
  const response =
    await apiAuthClient.get<GetDocumentQueueGroupsResponseType>(url);

  return response.data;
};
